import React, { useState, useEffect } from "react";
import axios from "axios";
import { ThemeProvider, createTheme, styled } from "@mui/material/styles";
import MUIDataTable from "mui-datatables";
import {
  TextField,
  Checkbox,
  Button,
  IconButton,
  TableFooter,
  TableRow,
  TableCell,
  Stack,
  Typography,
  Pagination,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import RefreshIcon from "@mui/icons-material/Refresh";
import { toHalfWidth, toFullWidthKatakana, normalizePhoneNumber } from "./tool";

const theme = createTheme({
  typography: {
    fontSize: 12, // ここで全体のフォントサイズを設定
  },
});

const StyledMUIDataTable = styled(MUIDataTable)({
  // "& .MuiTableCell-root": {
  //   padding: "12px", // セルのpaddingを調整
  // },
});

export default function SalesAgentLists() {
  const [salesAgentData, setSalesAgentData] = useState();
  const [lineEditInfo, setLineEditInfo] = useState({
    optionFilter: true,
    optionSearch: true,
    editSalesAgentID: null,
    editSalesAgentData: null,
  });

  const [page, setPage] = useState(0); // 現在のページ

  // ページ変更時
  const handleChangePage = (event, pageNo) => {
    // setPageChangeClicked(true);
    setPage(pageNo - 1);
  };

  // ****************************************************
  // 初回起動時の処理
  // ****************************************************

  useEffect(() => {
    getSalesAgentLists();
  }, []);

  /*************************************************************
    処理状況一覧更新
  **************************************************************/
  const handleUpdateClick = () => {
    getSalesAgentLists();
  };

  /*************************************************************
    一覧取得
  **************************************************************/
  async function getSalesAgentLists() {
    const webApiUrl = process.env.REACT_APP_LAMBDA_API_URL; // LambdaのAPI URL
    try {
      const apiUrl = `${webApiUrl}/getSalesAgentLists`;
      const headers = {
        "Content-Type": "application/json",
      };
      const requestData = {};
      console.log("API call (getSalesAgentLists request", requestData);
      const response = await axios.get(apiUrl, requestData, { headers });
      console.log("API call (getSalesAgentLists response", response);

      // HTTP ステータスコードに応じたエラーハンドリング
      if (response.status !== 200 || response.data.code !== 200) {
        throw new Error(
          "getSalesAgentLists API Error" +
            (response.data.message ? "（" + response.data.message + ")" : "")
        );
      }

      const items = response.data.body.salesAgentLists;

      setSalesAgentData(items);
    } catch (error) {
      if (error.response) {
        const { status, statusText } = error.response;
        console.log(`◆◆◆ Error ◆◆◆ HTTP Status: ${status} ${statusText}`);
      } else {
        console.log("◆◆◆ Error ◆◆◆ ", error.message);
      }
    }
  }

  /*************************************************************
    保存更新処理
  **************************************************************/
  const saveSalesAgentInfomationRegist = async (salesAgentInfo) => {
    const webApiUrl = process.env.REACT_APP_LAMBDA_API_URL; // LambdaのAPI URL
    const apiUrl = `${webApiUrl}/putSalesAgentInfo`;
    try {
      const requestData = salesAgentInfo;
      const headers = {
        "Content-Type": "application/json",
      };

      console.log("API call (putSalesAgentInfo request", requestData);
      const response = await axios.put(apiUrl, requestData, { headers });
      console.log("API call (putSalesAgentInfo response", response);

      // HTTP ステータスコードに応じたエラーハンドリング
      if (response.status !== 200 || response.data.code !== 200) {
        throw new Error(
          "putSalesAgentInfo API Error" +
            (response.data.message ? "（" + response.data.message + ")" : "")
        );
      }
    } catch (error) {
      if (error.response) {
        const { status, statusText } = error.response;
        console.log(`◆◆◆ Error ◆◆◆ HTTP Status: ${status} ${statusText}`);
      } else {
        console.log("◆◆◆ Error ◆◆◆ ", error.message);
      }
    } finally {
    }
  };

  // ****************************************************
  // 編集開始、更新、保存、キャンセル
  // ****************************************************
  // 編集開始
  const handleLineEditStart = (salesAgentID) => {
    const salesAgent = salesAgentData.find(
      (agent) => agent.id === salesAgentID
    );
    setLineEditInfo((prevState) => ({
      ...prevState,
      editSalesAgentData: salesAgent ? { ...salesAgent } : null,
      editSalesAgentID: salesAgentID,
      optionFilter: false,
      optionSearch: false,
    }));
  };

  // テーブルの値を更新
  const handleUpdateValue = (columnName, value) => {
    setLineEditInfo((prevState) => ({
      ...prevState,
      editSalesAgentData: {
        ...prevState.editSalesAgentData,
        [columnName]: value,
      },
    }));
  };
  const handleUpdateValue2 = (columnName, value) => {
    setLineEditInfo((prevState) => ({
      ...prevState,
      editSalesAgentData: {
        ...prevState.editSalesAgentData,
        [columnName]:
          columnName === "tel"
            ? normalizePhoneNumber(toHalfWidth(value))
            : toFullWidthKatakana(toHalfWidth(value)),
      },
    }));
  };

  // 編集中の行の保存
  const handleLineSave = () => {
    if (!lineEditInfo.editSalesAgentData) return;

    const updatedSalesAgentData = salesAgentData.map((agent) =>
      agent.id === lineEditInfo.editSalesAgentID
        ? lineEditInfo.editSalesAgentData
        : agent
    );

    saveSalesAgentInfomationRegist(lineEditInfo.editSalesAgentData);
    setSalesAgentData(updatedSalesAgentData);

    setLineEditInfo((prevState) => ({
      ...prevState,
      editSalesAgentID: null,
      editSalesAgentData: null,
      optionFilter: true,
      optionSearch: true,
    }));
  };

  // 編集中の行のキャンセル
  const handleEditCancel = () => {
    setLineEditInfo((prevState) => ({
      ...prevState,
      editSalesAgentID: null,
      editSalesAgentData: null,
      optionFilter: true,
      optionSearch: true,
    }));
  };

  // ****************************************************
  // 有効|無効 レンダリング
  // ****************************************************
  const renderEditableCheckbox = (
    value,
    tableMeta,
    updateValue,
    field,
    label
  ) => {
    const agentID = tableMeta.rowData[0];
    const isEditing = agentID === lineEditInfo.editSalesAgentID;
    const currentData = isEditing ? lineEditInfo.editSalesAgentData : null;
    const isChecked = currentData ? currentData[field] === 1 : value === 1;

    if (isEditing) {
      return (
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked}
              onChange={(e) =>
                handleUpdateValue(field, e.target.checked ? 1 : 0)
              }
              color="primary"
            />
          }
          label={label}
        />
      );
    } else {
      return isChecked ? "○" : ""; // チェックボックスがオンの場合「有効」を表示
    }
  };

  // ****************************************************
  // 販売代理店、部署名、電話番号 レンダリング
  // ****************************************************
  const renderEditableTextField = (
    value,
    tableMeta,
    updateValue,
    field,
    label
  ) => {
    const agendID = tableMeta.rowData[0]; // 販売代理店IDを取得
    const isEnable = tableMeta.rowData[1] === 1; // 有効|無効の値を取得

    if (agendID === lineEditInfo.editSalesAgentID) {
      const currentData = lineEditInfo.editSalesAgentData;
      return (
        <TextField
          label={label}
          value={
            currentData?.[field] !== undefined ? currentData?.[field] : value
          }
          multiline={true}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.preventDefault();
          }}
          fullWidth
          InputProps={{
            style: {
              fontSize: "12px",
            },
          }}
          onChange={(e) => handleUpdateValue(field, e.target.value)}
          onCompositionEnd={(e) => handleUpdateValue2(field, e.target.value)}
        />
      );
    } else {
      return field === "company" ? (
        <span style={{ color: isEnable ? "inherit" : "gray" }}>{value}</span>
      ) : (
        value
      );
    }
  };

  // ****************************************************
  // 住所レンダリング
  // ****************************************************
  const renderAddressFields = (agentID, addressInfo, currentData) => (
    <>
      {["prefectures", "city", "town", "street", "building"].map((field) => (
        <TextField
          key={field}
          label={
            field === "prefectures"
              ? "都道府県"
              : field === "city"
              ? "市区郡"
              : field === "town"
              ? "町村"
              : field === "street"
              ? "番地"
              : "ビル名"
          }
          value={
            currentData?.[field] !== undefined
              ? currentData?.[field]
              : addressInfo[field]
          }
          onChange={(e) => handleUpdateValue(field, e.target.value)}
          onCompositionEnd={(e) => handleUpdateValue2(field, e.target.value)}
          style={{ margin: "6px", fontSize: "12px" }}
          fullWidth={field === "building"}
        />
      ))}
    </>
  );

  const formatAddress = (info, enable) => {
    // const fontColor = enable === 1 ? "inherit" : "gray";

    return (
      // <span>指定すると、検索対象にならない不具合が発生する
      // 住所以外の項目は問題ないのだが原因は不明
      // よって、有効無効行に関係なく、住所は色変更を行わない
      // 住所のほか、部署名、電話番号も同様に色変更を行わない
      // <span style={{ color: fontColor }}>
      //   {info.prefectures} {info.city} {info.town} {info.street} {info.building}
      // </span>
      info.prefectures +
      " " +
      info.city +
      " " +
      info.town +
      " " +
      info.street +
      " " +
      info.building
    );
  };

  // compay, tel, city, town, streetのいずれかが空欄の場合は return trud（DB登録不可）
  const isDBRegistration = (agentID) => {
    const { company, tel, city, town, street } = salesAgentData.find(
      (info) => info.id === agentID
    );
    const fields = { company, tel, city, town, street };
    const currentData = lineEditInfo.editSalesAgentData;

    const work = Object.keys(fields).map((key) =>
      currentData?.[key] !== undefined ? currentData?.[key] : fields[key]
    );
    return work.some((value) => value === "");
  };

  const columns = [
    // ****************************************************
    // ID
    // ****************************************************
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    // ****************************************************
    // 有効｜無効
    // ****************************************************
    {
      name: "enable",
      label: "有効",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) =>
          renderEditableCheckbox(
            value,
            tableMeta,
            updateValue,
            "enable",
            "有効"
          ),
      },
    },
    // ****************************************************
    // 代理店名
    // ****************************************************
    {
      name: "company",
      label: "代理店名",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) =>
          renderEditableTextField(
            value,
            tableMeta,
            updateValue,
            "company",
            "代理店名"
          ),
      },
    },
    // ****************************************************
    // 部署名
    // ****************************************************
    {
      name: "department",
      label: "部署名",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) =>
          renderEditableTextField(
            value,
            tableMeta,
            updateValue,
            "department",
            "部署名"
          ),
      },
    },
    // ****************************************************
    // 電話番号
    // ****************************************************
    {
      name: "tel",
      label: "電話番号",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) =>
          renderEditableTextField(
            value,
            tableMeta,
            updateValue,
            "tel",
            "電話番号"
          ),
      },
    },
    // ****************************************************
    // 住所
    // ****************************************************
    {
      name: "address",
      label: "住所",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const agentID = tableMeta.rowData[0];
          const addressInfo = salesAgentData.find(
            (info) => info.id === agentID
          );

          if (agentID === lineEditInfo.editSalesAgentID) {
            const currentData = lineEditInfo.editSalesAgentData;
            return renderAddressFields(agentID, addressInfo, currentData);
          } else {
            return formatAddress(addressInfo, tableMeta.rowData[1]);
          }
        },
      },
    },

    // ****************************************************
    // 編集
    // ****************************************************
    {
      name: "edit",
      label: "編集",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (tableMeta.rowData[0] === lineEditInfo.editSalesAgentID) {
            return (
              <>
                <Button
                  onClick={() => handleLineSave(tableMeta.rowData[0])}
                  disabled={isDBRegistration(tableMeta.rowData[0])}
                >
                  保存
                </Button>
                <Button onClick={() => handleEditCancel()}>キャンセル</Button>
              </>
            );
          } else if (
            lineEditInfo.editSalesAgentID === null ||
            lineEditInfo.editSalesAgentID !== tableMeta.rowData[0]
          ) {
            return (
              <Button
                onClick={() => handleLineEditStart(tableMeta.rowData[0])}
                disabled={lineEditInfo.editSalesAgentID !== null}
              >
                編集
              </Button>
            );
          }
        },
      },
    },
  ];

  // ****************************************************
  // options
  // ****************************************************
  const options = {
    // responsive: "vertical",
    filterType: "dropdown",
    selectableRows: "none",
    print: false,
    search: false, // 検索アイコンを非表示
    download: false,
    viewColumns: false,
    filter: lineEditInfo.optionFilter,
    searchAlwaysOpen: lineEditInfo.optionSearch,
    sortOrder: {
      name: "company", // ソートされる列の名前
      direction: "asc", // ソート方向 ("asc" or "desc")
    },
    textLabels: {
      body: {
        noMatch: "Loading data or no matching data",
      },
    },
    page: page,
    customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
      return (
        <TableFooter>
          <TableRow>
            <TableCell colSpan={6}>
              <Stack
                spacing={2}
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Pagination
                  count={Math.ceil(count / rowsPerPage)}
                  page={page + 1} // Paginationコンポーネントは1から始まるため、+1する
                  onChange={(event, newPage) =>
                    handleChangePage(event, newPage)
                  }
                />
                <Typography sx={{ fontSize: "0.8rem" }}>
                  {page * 10 + 1}-
                  {page * 10 + 10 <= count ? page * 10 + 10 : count} of {count}
                </Typography>
              </Stack>
            </TableCell>
          </TableRow>
        </TableFooter>
      );
    },
  };

  return (
    <>
      <IconButton onClick={handleUpdateClick}>
        <RefreshIcon />
        <span style={{ fontSize: "0.9rem" }}>Refresh</span>
      </IconButton>
      <ThemeProvider theme={theme}>
        <StyledMUIDataTable
          data={salesAgentData}
          columns={columns}
          options={options}
        />
      </ThemeProvider>
    </>
  );
}
